import { useEffect, useState } from "react";
import { PlusIcon } from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";

export default function InternalNotes({
  currentUserId = null,
  userUserId = null,
}) {
  const { t } = useTranslation();
  const [newNote, setNewNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [internalNotes, setInternalNotes] = useState([]);

  useEffect(() => {
    const loadNotes = async () => {
      if (!userUserId) return;
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/InternalNotes/${userUserId}`
        );
        const data = await res.json();
        setInternalNotes(data || []);
      } catch (err) {
        console.error("Erreur chargement notes internes :", err);
      }
    };

    loadNotes();
  }, [userUserId]);

  const handleAddNote = async () => {
    if (!newNote.trim() || !currentUserId || !userUserId) return;

    const noteToSend = {
      text: newNote.trim(),
      addedBy: currentUserId,
      userId: userUserId,
    };

    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/InternalNotes`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-User-Id": currentUserId,
          },
          body: JSON.stringify(noteToSend),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
      }

      const savedNote = await response.json();
      setInternalNotes([savedNote, ...internalNotes]);
      setNewNote("");
    } catch (err) {
      alert("Erreur lors de l'ajout de la note interne : " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="text-sm italic text-muted">
        {t("subscriptionModal.autoSaveNote")}
      </div>
      <div>
        <label className="label">
          <span className="label-text">{t("subscriptionModal.addNote")}</span>
        </label>
        <textarea
          className="textarea textarea-bordered w-full"
          rows={3}
          value={newNote}
          onChange={(e) => setNewNote(e.target.value)}
          placeholder={t("subscriptionModal.writeNote")}
        />
        <button
          className="btn btn-sm mt-2 bg-primary text-white rounded-full"
          onClick={handleAddNote}
          disabled={loading}
        >
          {t("global.add")} <PlusIcon className="h-4 w-4 inline-block" />
        </button>
      </div>

      <div className="divider" />

      <div className="space-y-2">
        {internalNotes.length === 0 ? (
          <p className="text-sm text-gray-400 italic">
            {t("subscriptionModal.noNotes")}
          </p>
        ) : (
          internalNotes.map((note) => (
            <div
              key={note.id || note.createdAt || Math.random()}
              className="bg-gray-50 border rounded p-3 text-sm shadow-sm"
            >
              <div className="text-xs text-gray-500 mb-1">
                {note.createdAt
                  ? new Date(note.createdAt).toLocaleString()
                  : ""}
              </div>
              <div className="whitespace-pre-wrap">{note.text}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
